import React from 'react';
import ReactDOM from 'react-dom';
import {Modal, Button} from 'react-bootstrap';

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  cancelBtn = 'Cancel',
  confirmBtn = 'Confirm',
  hideCancel = false,
  headTitle = 'Confirmation!',
}) => {
  return (
    <Modal
      show={show}
      onHide={() => onHide('close')}
      centered
      scrollable
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <h6>{headTitle}</h6>
      </Modal.Header>
      <Modal.Body>
        <h5>{title || 'Confirm action'} </h5>
        <div className="text-right">
          {!hideCancel ? (
            <Button
              variant="secondary"
              type="button"
              onClick={() => onHide('cancel')}
              style={{margin: '5px'}}
            >
              {cancelBtn}
            </Button>
          ) : null}
          <Button type="button" onClick={onConfirm} style={{margin: '5px'}}>
            {confirmBtn}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const ConfirmParent = ({id, ...props}) => {
  const [isOpen, toggleOpen] = React.useState(true);
  React.useEffect(() => {
    toggleOpen(true);
  }, [id]);

  return (
    <ConfirmationModal
      {...props}
      show={isOpen}
      onConfirm={() => {
        toggleOpen(false);
        props.onConfirm();
      }}
      onHide={(mode) => {
        toggleOpen(false);
        props.onHide(mode);
      }}
    />
  );
};

const ConfirmationModalPromise = (props) => {
  return new Promise((resolve, reject) => {
    ReactDOM.render(
      <ConfirmParent
        id={+new Date()}
        {...props}
        onHide={(mode) => {
          reject(mode);
        }}
        onConfirm={() => {
          resolve();
        }}
      />,
      document.getElementById('cce-confirm-model-container')
    );
  });
};

export {ConfirmationModalPromise};
export default ConfirmationModal;
